import * as React from 'react';

import { Card, CardContent, CardFooter, CardHeader } from './components/ui/card.js';
import { cn } from './lib/utils.js';

/** The card shell a multi-step flow lives in: stepper on top, fields, then its actions. */
export function DimeWizard({ className, ...props }: Readonly<React.ComponentProps<typeof Card>>) {
  return (
    <Card role="group" data-slot="wizard" className={cn('gap-0 py-0', className)} {...props} />
  );
}

export function DimeWizardHeader({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof CardHeader>>) {
  return (
    <CardHeader
      data-slot="wizard-header"
      className={cn('border-b px-6 py-5', className)}
      {...props}
    />
  );
}

export function DimeWizardContent({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof CardContent>>) {
  return (
    <CardContent
      data-slot="wizard-content"
      className={cn('flex flex-col gap-5 px-6 py-6', className)}
      {...props}
    />
  );
}

export function DimeWizardFooter({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof CardFooter>>) {
  return (
    <CardFooter
      data-slot="wizard-footer"
      className={cn('flex items-center justify-between border-t px-6 py-4', className)}
      {...props}
    />
  );
}
